import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapComponent } from '@shared/components/map/components/map/map.component';
import { FilterCatalogItemsModule } from '@shared/components/filter-catalog-items/filter-catalog-items.module';
import { SvgModule } from '@shared/components/svg/svg.module';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicUpdateInfoModule } from '@shared/components/dynamic-update-info/dynamic-update-info.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoaderModule } from '@shared/components/loader/loader.module';

@NgModule({
  declarations: [MapComponent],
  imports: [
    CommonModule,
    FormsModule,
    FilterCatalogItemsModule,
    SvgModule,
    NgLetModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    TranslateModule,
    DynamicUpdateInfoModule,
    MatTooltipModule,
    LoaderModule
  ],
  exports: [MapComponent]
})
export class MapModule {}
